// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1614":"css/app.6954","2424":"css/admin-app.6954"}[chunkId] + ".css";
};